import { AxiosPromise } from 'axios';
import { DashboardNotifications } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const getDashboardSeenNotifications = (): AxiosPromise<DashboardNotifications[]> => {
    const { Accounts } = request();
    return Accounts.accountsDashboardsettingsSeennotificationGet();
};

export const setDashboardSeenNotification = (
    notification: DashboardNotifications
): AxiosPromise<DashboardNotifications[]> => {
    const { Accounts } = request();
    return Accounts.accountsDashboardsettingsSeennotificationPut(notification);
};
